export enum SearchMakersWithFiltersSortBy {
  /**
   * trunk-ignore(buf-lint/ENUM_FIRST_VALUE_ZERO): This enum starts at 1 for legacy reasons
   */
  NAME = 'NAME',
  SCORE = 'SCORE',
  FIRST_ACTIVE_AT = 'FIRST_ACTIVE_AT',
  MINIMUM = 'MINIMUM',
  STOCKIST = 'STOCKIST',
  TRENDING_AT_PROMOTIONAL_EVENT = 'TRENDING_AT_PROMOTIONAL_EVENT',
  RECENTLY_FOLLOWED = 'RECENTLY_FOLLOWED',
}
